
import { defineComponent, PropType, reactive, ref, watch, inject, onMounted } from "vue";
import { flowHooks } from "@/hooks/factoryHooks";
import { ElNotification, ElLoading, ElImageViewer, ElMessageBox } from "element-plus";
import $api from "@/api/main";
import utils from "@/utils/utils";
import router from "@/router";
import { baseURL } from "@/utils/request";
import Bus from "@/bus";
import { ElMessage } from "element-plus";
export default defineComponent({
	props: {
		/**
		 * 是否自动上传
		 */
		autoUpload: {
			type: Boolean,
			default: true,
		},
		/**
		 * 是否需要下载
		 */
		needDownLoad: {
			type: Boolean,
			default: false,
		},
		/**
		 * 是否禁用
		 */
		disabled: {
			type: Boolean,
			default: false,
		},

		/**
		 * 回显文件列表
		 */
		fileLists: {
			type: Array,
			default: () => [],
		},

		/**
		 * 文件个数限制
		 */
		limit: {
			type: Number,
			default: 99,
		},

		/**
		 * 是否可以多选
		 */
		multiple: {
			type: Boolean,
			default: false,
		},

		/**
		 * 上传框类型
		 * 可选值： normal/drag/avatar
		 */
		uploadStyle: {
			type: String,
			default: "normal",
		},

		/**
		 * 文件预览类型
		 * 可选值： local/plugin
		 */
		previewType: {
			type: String,
			default: "plugin",
		},

		/**
		 * 已上传图片显示方式
		 * 可选值： text/picture/picture-card
		 */
		listType: {
			type: String,
			default: "text",
		},

		/**
		 * 接收文件的类型
		 */
		accept: {
			type: String,
			default: "",
		},

		/**
		 * 文件发生变化的回调
		 */
		onChange: {
			/* eslint-disable */
			type: Function as PropType<() => void>,
			default: () => {
				return () => {};
			},
		},
		/**
		 * 文件上传Url
		 */
		actionUrl: {
			type: String,
			default: "",
		},
		/**
		 * 文件上传参数名
		 */
		paramsName: {
			type: String,
			default: "files",
		},
	},
	emits: ["getResult"],
	setup(props, ctx: any) {
		const { previewFn } = flowHooks();
		const previewObj: any = reactive({
			visible: false,
			urlList: [],
			index: 0,
		});
		let uploadParamsName = props.paramsName ? props.paramsName : "files";
		// 上传loading实例
		let loading: any = null;
		let downloadLoading: any = null;
		// 默认上传地址
		const actionUrl = props.actionUrl
			? `${baseURL}${props.actionUrl}`
			: `${baseURL}file/upload/file`;
		// 上传需要携带的header
		let uploadHeader = {
			Authorization: decodeURIComponent(utils.$cookie.getCookie(utils.$tokenStr)),
		};

		// 传输进来的默认文件列表
		const fileDataList: any = reactive({
			fileList: [],
		});
		// 是否显示上传组件
		let isExceed = ref(false);
		isExceed.value = props.disabled;

		// 根据传入的数据回显
		const echoDataFn = () => {
			// 判断传入的数据是否为空，如果不为空则修改成element-plus能识别的字段名称
			if (props.fileLists && props.fileLists.length > 0) {
				if (props.fileLists.length >= props.limit) isExceed.value = true;
				fileDataList.fileList = [];
				previewObj.urlList = [];
				props.fileLists.forEach((item: any) => {
					fileDataList.fileList.push({
						fileId: item.fileId,
						name: item.fileName,
						url: `${baseURL}public/file/${item.fileId}?token=${utils.$cookie.getCookie(
							utils.$tokenStr
						)}`,
					});
					if (
						item.fileName &&
						(item.fileName.indexOf("png") !== -1 ||
							item.fileName.indexOf("jpg") !== -1 ||
							item.fileName.indexOf("jpeg") !== -1)
					) {
						previewObj.urlList.push(
							`${baseURL}public/file/${item.fileId}?token=${utils.$cookie.getCookie(
								utils.$tokenStr
							)}`
						);
					}
				});
			} else {
				fileDataList.fileList = [];
			}
		};
		echoDataFn();

		/**
		 * 监听fileLists变化
		 */
		watch(
			() => props.fileLists,
			(val) => {
				echoDataFn();
			}
		);
		watch(
			() => props.disabled,
			(val) => {
				isExceed.value = val;
			}
		);

		// 上传成功的回调函数
		const onSuccess = (res: any, file: any, fileList: any) => {
			console.log(res);
			loading.close();
			if (fileList.length >= props.limit) isExceed.value = true;
			if (props.uploadStyle !== "btn") {
				mixData(fileList);
			}
			if (res.code !== 200) {
				ElNotification({
					title: "错误",
					dangerouslyUseHTMLString: true,
					message: res.msg,
					type: "error",
				});
			}else{
				ctx.emit("uploadSucces", res);
			}
		};
		// 移除文件的回调函数
		const onRemove = (files: any, fileList: any) => {
			if (fileList.length < props.limit) isExceed.value = false;
			mixData(fileList);
		};
		// 移除文件的回调函数
		const handleRemove = (files: any) => {
			fileDataList.fileList.forEach((item: any, index: any) => {
				if (item.fileId === files.fileId) {
				fileDataList.fileList.splice(index, 1);
				}
			});
			if (fileDataList.fileList.length < props.limit) isExceed.value = false;

			mixData(fileDataList.fileList);
		};
		// 上传失败的回调函数
		const onError = (err: any, file: any, fileList: any) => {
			loading.close();
			let error = JSON.parse(err.message);
			if (error.code == 401) {
				ElMessage({
					message: "登录信息过期，请重新登录!",
					showClose: true,
					type: "warning",
				});
				setTimeout(function () {
					utils.$cookie.clearToken();
					router.push({
						path: "/login",
					});
				}, 2000);
			} else {
				ElNotification({
					title: "错误",
					message: `文件上传错误，请稍后再试!`,
					type: "error",
				});
			}
		};
		// 上传文件前的回调函数
		const onBeforeUpload = (file: any) => {
			// 限制20M
			let isFitSize = file.size / 1024 / 1024 < 50;
			if (!isFitSize) {
				ElNotification({
					title: "错误",
					message: `文件上传错误，文件大小不能超过50兆(MB)!`,
					type: "error",
				});
			}
			if (props.accept) {
				let str = props.accept.replaceAll(".", "");
				let arr = str.split(",");
				let fileName = file.name.substring(file.name.lastIndexOf(".") + 1);
				if (arr.indexOf(fileName) == -1) {
					ElNotification({
						title: "错误",
						message: `只能上传 ${props.accept}文件!`,
						type: "error",
					});
					isFitSize = false;
				}
			}
			if (isFitSize) {
				loading = ElLoading.service({
					lock: true,
					text: "文件上传中，请稍后!",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.2)",
				});
			}

			return isFitSize;
		};
		// 文件预览的回调函数
		const onPreview = async (file: any) => {
			let fileId = "",
				fileName = "";
			if (file.hasOwnProperty("fileId")) {
				fileId = file.fileId;
				fileName = file.name;
				if (!fileName) {
					let file = await $api.getFileDetail(fileId);
					fileName = file.fileName;
				}
			} else {
				fileId = file.response.data[0].id;
				fileName = file.response.data[0].fileName;
			}
			if (props.needDownLoad) {
				ElMessageBox.confirm(
					"请注意：加密文件只能下载无法预览，请实际情况选择!",
					"请选择",
					{
						distinguishCancelAndClose: true,
						confirmButtonText: "预览",
						cancelButtonText: "下载",
					}
				)
					.then(() => {
						if (
							props.previewType === "plugin" &&
							fileName.indexOf("png") === -1 &&
							fileName.indexOf("jpg") === -1 &&
							fileName.indexOf("jpeg") === -1
						) {
							previewFn(fileId, fileName);
						} else {
							previewObj.index = previewObj.urlList.findIndex((item:any) => {
								return item === file.url;
							});
							previewObj.visible = true;
						}
					})
					.catch((action) => {
						if (action === "cancel") {
							window.open(
								`${baseURL}public/file/${fileId}?token=${utils.$cookie.getCookie(
									utils.$tokenStr
								)}`
							);
						}
					});
			} else {
				if (
					props.previewType === "plugin" &&
					fileName.indexOf("png") === -1 &&
					fileName.indexOf("jpg") === -1 &&
					fileName.indexOf("jpeg") === -1
				) {
					previewFn(fileId, fileName);
				} else {
					previewObj.index = previewObj.urlList.findIndex((item:any) => {
						return item === file.url;
					});
					previewObj.visible = true;
				}
			}
		};

		// 超出文件数量限制的回调函数
		const onExceed = (files: any, fileList: any) => {
			ElNotification({
				title: "警告",
				message: `超出文件最大限制，最多只能上传${props.limit}个文件`,
				type: "warning",
			});
		};

		// 整合返回数据
		const mixData = (dataList: Array<Object>) => {
			let result: Array<Object> = [];
			dataList.forEach((item: any) => {
				if (item.hasOwnProperty("fileId")) {
					result.push({
						fileName: item.name,
						fileId: item.fileId,
					});
				} else {
					result.push({
						fileName: item.name,
						fileId: item.response.data[0].id,
					});
				}
			});
			ctx.emit("getResult", result);
		};
		//下载
		const downFile = (file: any) => {
			downloadLoading = ElLoading.service({
				lock: true,
				text: "文件下载中，请稍后!",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.2)",
			});
			const url = file.url
			let x = new XMLHttpRequest();
			x.open("GET", url, true);
			x.responseType = "blob";
			x.onload = function() {
				let url = window.URL.createObjectURL(x.response);
				let a = document.createElement("a");
				a.href = url;
				a.download = file.name;
				a.click();
			};
			x.send();
			x.onloadend = function() {
				downloadLoading.close();
			};
		};

		onMounted(() => {
			Bus.$on("refreshFlag", (flag: any) => {
				uploadHeader = {
					Authorization: decodeURIComponent(utils.$cookie.getCookie(utils.$tokenStr)),
				};
			});
		});

		return {
			actionUrl,
			uploadHeader,
			onSuccess,
			onRemove,
			onError,
			onBeforeUpload,
			onPreview,
			onExceed,
			handleRemove,
			downFile,
			fileDataList,
			isExceed,
			uploadParamsName,
			previewObj,
		};
	},
	mounted() {},
});
